/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const PointPreviousIcon = /*#__PURE__*/ createSvgIcon(
  'PointPreviousIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.24.5a.5.5 0 01.451.284l2.26 4.73.006.014c.368.834.709 1.392 1.098 1.744.366.332.804.508 1.445.508H19a.5.5 0 01.5.5v8.1a.5.5 0 01-.5.5h-2.152c-.749.74-1.35 1.157-1.903 1.38-.59.24-1.086.24-1.526.24H9.42a2.8 2.8 0 01-2.897-1.966 19.44 19.44 0 01-.821-3.341c-.046-.43-.096-1.183.275-1.834.029-.051.06-.1.093-.149h-3.22a2.128 2.128 0 01-2.19-2.996A2.13 2.13 0 012.85 6.98h7.981l-.147-.603c-.16-.663-.347-1.438-.443-1.868l-.001-.004c-.387-1.801-.014-2.863.634-3.45A2.167 2.167 0 0112.221.5H12.24V1 .5zm-.287 1.06a1.15 1.15 0 00-.406.235c-.289.262-.671.9-.329 2.498.094.42.278 1.184.439 1.848l.21.858.088.36-.485.121.485-.12a.5.5 0 01-.485.62H2.82a.504.504 0 01-.075-.006 1.13 1.13 0 10.007 2.24.494.494 0 01.068-.004H8.5a.5.5 0 010 1c-1.09 0-1.485.348-1.653.643-.198.348-.194.806-.151 1.223.166 1.068.426 2.12.777 3.142l.005.016A1.8 1.8 0 009.4 17.5h4c.444 0 .769-.003 1.17-.166.41-.166.942-.518 1.713-1.304a.5.5 0 01.357-.15h1.86v-7.1h-1c-.86 0-1.546-.25-2.117-.767-.548-.496-.956-1.211-1.337-2.074l-2.093-4.38z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default PointPreviousIcon;
